import { leftPad } from "../string/left-pad";
import isDate from "./check";

const months = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December",
];
const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

interface ToStrOptions {
	humanReadable?: boolean;
}

export default function toStr(
	dt: Date | string | number = new Date(),
	format: string = "MMM-DD-YYYY",
	options: ToStrOptions = {},
): string {
	// Handle different input types
	if (typeof dt === "string" || typeof dt === "number") {
		dt = new Date(dt);
	}

	if (!dt || !isDate(dt)) return "";

	// Handle human readable format
	if (options.humanReadable) {
		const now = new Date();
		const dayAfter = new Date(now.getTime() + 48 * 60 * 60 * 1000); // 48 hours from now

		if (dt < dayAfter) {
			const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()); // Start of today
			const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000); // Start of tomorrow
			const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000); // Start of yesterday

			if (dt < tomorrow) {
				if (dt >= today) return "today";
				else if (dt >= yesterday) return "yesterday";
			} else {
				return "tomorrow";
			}
		}
	}

	// Extract date components
	const s = dt.getSeconds();
	const m = dt.getMinutes();
	const H = dt.getHours();
	const h = H > 12 ? H - 12 : H;
	const D = dt.getDate();
	const Day = dt.getDay();
	const M = dt.getMonth();
	const Y = dt.getFullYear();

	// Replace format tokens
	let result = format;
	result = result.replace("ss", leftPad(s, 2));
	result = result.replace("s", s.toString());
	result = result.replace("mm", leftPad(m, 2));
	result = result.replace("m", m.toString());
	result = result.replace("hh", leftPad(h, 2));
	result = result.replace("h", h.toString());
	result = result.replace("HH", leftPad(H, 2));
	result = result.replace("H", H.toString());
	result = result.replace("A", H < 12 ? "am" : "pm");
	result = result.replace("DD", leftPad(D, 2));
	result = result.replace("D", D.toString());
	result = result.replace("MMMM", months[M]);
	result = result.replace("MMM", months[M].substring(0, 3));
	result = result.replace("MM", leftPad(M + 1, 2));
	result = result.replace(/M(?![ao])/, (M + 1).toString());
	result = result.replace("DDDD", days[Day]);
	result = result.replace("DDD", days[Day].substring(0, 3));
	result = result.replace("YYYY", Y.toString());
	result = result.replace("YY", Y.toString().substring(2));

	return result;
}
